<template>
<!-- 三级树结构 -->
  <div id="tree" style="margin-left: 10px;">
    <div class="tree-container">
      <!-- 一级 -->
      <div class="first-level" v-for="(item, index) in newList" :key="index">
        <div class="first-level-innerbox">
          <div class="level-title">
            <span class="open_close_btn" @click="expandHandler(item)">
              <i v-show="item.expand" class="icon iconfont iconzhankai"></i>
              <i v-show="!item.expand" class="icon iconfont iconshouqi"></i>
            </span>
            <span class="text">{{item.description}}</span>
            <span class="mycheckbox">
              <!-- indeterminate不确定的, js动态添加class-->
              <input @click="hanlderClick($event, item)" v-model="item.checked" :disabled="disabled" type="checkbox" :class="{'allCheckbox':true, 'indeterminate': item.indeterminate && !item.checked}" :id="'firCheckbox' + index" name="checbox" />
              <label :for="'firCheckbox' + index" style="width: 15px;height: 15px;"></label>
            </span>
          </div>
          <!-- 二级 -->
          <!-- item.childMenus && item.childMenus.length > 0 -->
          <div v-show="item.expand" class="next-level" :style="item.childMenus && item.childMenus.length > 0 ? '' : 'margin: 0;'">
            <div class="second-level" v-for="(val, idx) in item.childMenus" :key="idx">
              <div class="second-level-innerbox">
                <div class="level-title">
                  <span class="open_close_btn" @click="expandHandler(val)">
                    <i v-show="val.expand" class="icon iconfont iconzhankai"></i>
                    <i v-show="!val.expand" class="icon iconfont iconshouqi"></i>
                  </span>
                  <span class="text">{{val.description}}</span>
                  <span class="mycheckbox">
                    <!-- indeterminate不确定的, js动态添加class-->
                    <input @click="hanlderClick($event, val, item)" v-model="val.checked" :disabled="disabled" type="checkbox" :class="{'allCheckbox':true, 'indeterminate': val.indeterminate && !val.checked}" :id="'secCheckbox' + idx" name="checbox" />
                    <label :for="'secCheckbox' + idx" style="width: 15px;height: 15px;"></label>
                  </span>
                </div>
              </div>
              <!-- 三级 -->
              <div v-show="val.expand" class="next-level" :style="val.childMenus && val.childMenus.length > 0 ? 'margin-top:5px;padding-left:25px;' : 'margin: 0;'">
                <div class="third-level" v-for="(v, i) in val.childMenus" :key="i">
                  <div class="third-level-innerbox">
                    <div class="level-title">
                      <span class="open_close_btn" @click="expandHandler(v)">
                        <i v-show="v.expand" class="icon iconfont iconzhankai"></i>
                        <i v-show="!v.expand" class="icon iconfont iconshouqi"></i>
                      </span>
                      <span class="text">{{v.description}}</span>
                      <span class="mycheckbox">
                        <input @click="hanlderClick($event, v, val, item)" v-model="v.checked" :disabled="disabled" type="checkbox" class="allCheckbox" :id="'thirCheckbox' + i" name="checbox" />
                        <label :for="'thirCheckbox' + i" style="width: 15px;height: 15px;"></label>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'tree',
  props: {
    data: {
      // 菜单list 最多三级
      type: Array,
      default: []
    },
    expandAll: {
      // 全部展开
      type: Boolean,
      default: false
    },
    disabled: {
      // 禁用
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      newList: []
    }
  },
  created () {

  },
  mounted () {
    // this.newList = this.data
    // this.newList = this.checkChildren(this.data)
  },
  methods: {
    checkChildren (arr) {
      console.log(arr, 'checkChildren')
      for (let i = 0; i < arr.length; i++) {
        if (!(arr[i].hasOwnProperty('expand'))) {
          if (this.expandAll) {
            arr[i].expand = true
          } else {
            arr[i].expand = false
          }
        }
        if (!(arr[i].hasOwnProperty('checked'))) {
          // 用来记录checkbox状态 true选中，false为选中
          arr[i].checked = false
        }
        if (!(arr[i].hasOwnProperty('indeterminate'))) {
          // 用来记录checkbox状态 indeterminate不确定的，默认false
          // 如果有子节点且部分为选中状态，则当前节点为indeterminate状态为true，checked状态应该为false
          // 如果有子节点且全部为选中状态，则当前节点为indeterminate状态false，checked状态应该为true
          arr[i].indeterminate = false
        }
        if (arr[i].childMenus && arr[i].childMenus.length > 0) {
          this.checkChildren(arr[i].childMenus)
        }
      }
      return arr
    },
    expandHandler (item) {
      item.expand = !item.expand
      this.$forceUpdate()
    },
    checkParentStatus (superiorNode) {
      if (superiorNode.childMenus && superiorNode.childMenus.length > 0) {
        let childrenList = superiorNode.childMenus
        let flag = childrenList.every(item => item.checked)
        if (flag) {
          superiorNode.checked = true
          superiorNode.indeterminate = false
        } else {
          let flagSome = childrenList.some(item => item.checked)
          console.log(childrenList, 'childrenList')
          console.log(flagSome, 'flagSome')
          let flagSome2 = childrenList.some(item => item.indeterminate)
          if (flagSome || flagSome2) {
            superiorNode.checked = false
            superiorNode.indeterminate = true
          } else {
            superiorNode.checked = false
            superiorNode.indeterminate = false
          }
        }
        this.$forceUpdate()
        console.log(superiorNode, 'superiorNode')
      }
    },
    checkChildrenStatus (node, status) {
      console.log(node, 'checkChildrenStatus')
      for (let i = 0; i < node.length; i++) {
        node[i].checked = status
        if (node[i].checked) {
          node[i].indeterminate = false
        }
        if (node[i].childMenus && node[i].childMenus.length > 0) {
          this.checkChildrenStatus(node[i].childMenus, status)
        }
      }
      this.$forceUpdate()
    },
    hanlderClick (e, currentItem, superiorNode, topNode) {
      console.log(e, 'e')
      console.log(currentItem, 'currentItem')
      currentItem.checked = e.target.checked
      if (currentItem.checked) {
        currentItem.indeterminate = false
      }
      if (currentItem.childMenus && currentItem.childMenus.length > 0) {
        console.log(currentItem.childMenus, 'currentItem.childMenus')
        this.checkChildrenStatus(currentItem.childMenus, currentItem.checked)
      }
      if (superiorNode) {
        this.checkParentStatus(superiorNode)
      }
      if (topNode) {
        this.checkParentStatus(topNode)
      }
    },
    findParentNode (parentIdOfCurrentNode, allList) {
      let superiorNode // 上一级节点
      if (parentIdOfCurrentNode == 0) {
        console.log('0000000000')
        // 一级节点
        superiorNode = null
      } else {
        console.log('1111111111')
        // 非一级节点
        for (let i = 0; i < allList.length; i++) {
          if (parentIdOfCurrentNode == allList[i].id) {
            console.log('222222222222')
            superiorNode = allList[i]
            if (allList[i].childMenus && allList[i].childMenus.length > 0) {
              let childrenList = allList[i].childMenus
              // 判断所有兄弟节点是否都选中
              let flag = childrenList.every(item => item.checked)
              if (flag) {
                // 当前节点的父级的所有子节点为选中状态，也就是当前节点以及所有兄弟节点都为选中状态
                // 则当前节点的父节点状态为如下：
                allList[i].checked = true
                allList[i].indeterminate = false
              } else {
                // 当前节点的兄弟节点有未选中的
                // 则当前节点的父节点状态为如下：
                allList[i].checked = false
                allList[i].indeterminate = true
              }
            }
            allList[i].indeterminate = true
          } else {
            console.log('3333333333')
            if (allList[i].childMenus && allList[i].childMenus.length > 0) {
              this.findParentNode(parentIdOfCurrentNode, allList[i].childMenus)
            }
          }
        }
      }
      this.$forceUpdate()
      return superiorNode
    }
  },
  computed: {

  },
  watch: {
    data: {
      handler (newData) {
        console.log(newData, 'watch----data')
        this.newList = this.checkChildren(newData)
        // this.newList = newData
        console.log(this.newList, 'newList')
      },
      deep: true
    }
  }
}
</script>
<style scoped>
  .tree-container {
    padding: 10px;
    font-size: 14px;
  }
  .first-level {
    border-left: 1px dashed #666;
    position: relative;
    /* height: 160px; */
  }
  .first-level:last-child {
    border-left: none;
  }
  .first-level .first-level-innerbox {
    position: relative;
    top: -5px;
    left: -8px;
    padding-bottom: 6px;
  }
  .level-title {

  }
  .first-level .text {
    margin-left: 5px;
    display: inline-block;
    width: 180px;
  }
  .second-level .text {
    margin-left: 5px;
    display: inline-block;
    width: 155px;
  }
  .third-level .text {
    margin-left: 5px;
    display: inline-block;
    width: 130px;
  }
  .next-level {
    padding-left: 32px;
    margin-top: 20px;
  }
  .open_close_btn {
    background-color: #ffffff;
  }
  .second-level {
    position: relative;
  }
  .second-level .second-level-innerbox{
    position: relative;
    top: -5px;
    left: -8px;
    padding-bottom: 6px;
  }
  .second-level,
  .third-level {
    border-left: 1px dashed #666;
  }
  .second-level:last-child {
    border-left: none;
  }
  .third-level {
    position: relative;
  }
  .third-level:last-child  {
    border-left: none;
  }
  .third-level .third-level-innerbox{
    position: relative;
    top: -5px;
    left: -8px;
    padding-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/myComponents/tree.vue